import React, { Component } from 'react';
import { Button } from 'antd';
import { browserHistory } from 'react-router';
import './btn.less';

export const goBack = () => {
  browserHistory.go(-1);
};

export class BackBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Button id="btnn" icon="left" shape="circle" style={{ marginRight: 10 }} onClick={goBack} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/comm/BackBtn.js